import "@wistia/wistia-player"
import analyticsWistia from "../analytics/analytics-wistia"

type WistiaPlayerProps = {
  wistiaId: string
}

export default function WistiaEmbed(
  el: HTMLElement,
  { wistiaId }: WistiaPlayerProps,
) {
  const swatch = document.querySelector<HTMLImageElement>(
    "div[data-ca-wistia-player]>img",
  )

  if (swatch?.complete) {
    swatch.classList.remove("opacity-0")
    swatch.classList.add("opacity-100")
  } else {
    swatch?.addEventListener("load", function () {
      swatch.classList.remove("opacity-0")
      swatch.classList.add("opacity-100")
    })
  }

  const player = document.createElement("wistia-player")

  player.mediaId = wistiaId
  player.swatch = false
  player.classList.add(
    "block",
    "h-full",
    "w-full",
    "row-start-1",
    "col-start-1",
    "backdrop-blur-xs",
  )

  analyticsWistia(player)

  el.appendChild(player)
}
